module.exports = __webpack_public_path__ + "static/media/stadveckan.61899e0d.png";